import { useMemo } from 'react'

import type { LinkType } from 'types'

import useSeminars from 'hooks/useSeminars'
import fullDate from 'utilities/fullDate'
import { formatDate } from 'ui-component-library/utils/helpers'
import LocationCourseCards from 'ui-component-library/components/LocationCourseCards'
import { useSelector } from 'react-redux'
import { getTrainingLanguageStrings } from 'store/strings/selectors'

type Props = {
  courseLinkText: string
  seminarType: 'all'
  findCourseLink: LinkType
}

function LocationCourseCardsContainer({
  seminarType,
  courseLinkText,
  ...props
}: Props) {
  const { isLoading, seminars } = useSeminars({ seminarType, limit: 4 })
  const languageStrings = useSelector(getTrainingLanguageStrings)

  const cards = useMemo(() => {
    return seminars.map((seminar) => {
      const {
        startDate,
        endDate,
        isOnlineSeminar,
        location,
        locationName,
        url,
        shortName,
        language,
      } = seminar

      const date = fullDate(startDate, endDate)
      const startAndEndTime = `${formatDate(
        startDate,
        'h:mma',
      )} PT - ${formatDate(endDate, 'h:mma')} PT`

      return {
        date,
        isOnlineSeminar,
        location,
        locationName,
        seminarLabelText: shortName,
        startAndEndTime,
        hasSeminarLabel: seminarType === 'all',
        link: {
          text: languageStrings[language]
            ? languageStrings[language].registerButtonText
            : courseLinkText,
          url,
        },
      }
    })
  }, [seminarType, seminars])

  return <LocationCourseCards {...props} isLoading={isLoading} cards={cards} />
}

export default LocationCourseCardsContainer
